import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { PartnerMassUpdateModel } from 'Pages/pp'

export type MassUpdateCuratorState = {
	data: ResponseCatalog<PartnerMassUpdateModel>
	requestParams: RequestParams
}

const initialState: MassUpdateCuratorState = {
	data: new ResponseCatalog<PartnerMassUpdateModel>(),
	requestParams: new RequestParams(),
}

export namespace MassUpdateCuratorNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetAll = PayloadAction<ResponseCatalog<PartnerMassUpdateModel>>
	export type MassUpdate = PayloadAction<{
		manager_id: number
		params: { ids: string; manager_id: number } | { manager_id: number }
	}>
	export type GetAllSocket = PayloadAction<{
		source_manager_id: number
	}>
}

export const massUpdateCuratorSlice = createSlice({
	name: 'massUpdateCurator',
	initialState,
	reducers: {
		getAll: (state, action: MassUpdateCuratorNS.GetAll) => {},

		setAll: (state, action: MassUpdateCuratorNS.SetAll) => {
			state.data = action.payload
		},

		clearAll: (state) => {
			state.data = new ResponseCatalog<PartnerMassUpdateModel>()
			state.requestParams = new RequestParams()
		},

		setRequestParams: (state, action: MassUpdateCuratorNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		massUpdate: (state, action: MassUpdateCuratorNS.MassUpdate) => {},
		getAllSocket: (state, action: MassUpdateCuratorNS.GetAllSocket) => {},
	},
})
